import { render, staticRenderFns } from "./useRegistration.vue?vue&type=template&id=22bb514d&scoped=true&"
import script from "./useRegistration.vue?vue&type=script&lang=js&"
export * from "./useRegistration.vue?vue&type=script&lang=js&"
import style0 from "./useRegistration.vue?vue&type=style&index=0&id=22bb514d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bb514d",
  null
  
)

export default component.exports